export {};

$(function () {
    function setVerticalLine($collection, $block) {
        let top = 0;
        let height = 0;
        let last = $collection.length - 1;

        $collection.each(function (index, value) {
            let $item = $(value);

            if (index === 0) {
                let halfH = $item.outerHeight() / 2;
                height += halfH + 10;
                top = parseInt($item.css('margin-top')) + halfH;
            } else if (index === last) {
                height += ($item.outerHeight() / 2) + 10;
            } else {
                height += $item.outerHeight() + 20;
            }
        });
        $block.css({top: top, height: height});
    }

    setVerticalLine(
        $('.governance-structure-col--ll .governance-structure-item'),
        $('.governance-structure-col-border--ll')
    );

    setVerticalLine(
        $('.governance-structure-col--lr .governance-structure-item:not(:last-of-type)'),
        $('.governance-structure-col-border--lr')
    );
});


// WEBPACK FOOTER //
// ./js/main/module/governance-structure.js